import { AddJoinCommonRequirementsWizardUIManager } from "../../AddProjectJoinCommon/AddJoinCommonRequirementsWizardUIManager";
const _addStudyWizardSteps = ["WELCOME", "PROJECT_TYPE", "LEGAL_NAME", "STUDY_NAME", "TEAM_MEMBERS", "SUCCESS"];
export const addStudyWizardStepValues = _addStudyWizardSteps;
export class AddProjectRequirementsWizardUIManager extends AddJoinCommonRequirementsWizardUIManager {
}
